import { Outlet } from "react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import nautikaIcon from "@/assets/img/nautika.svg";
import plageBackground from "@/assets/img/plage-background.png";
import { useLocation } from "react-router";
import { toast } from "sonner";
import { authClient } from "@/lib/auth-client";
import { RightRenderer, LayoutCtx } from "@/hooks/useRightPanel";

function Header() {
  const location = useLocation();
  const path = location.pathname;
  const handleSignOut = async () => {
    if (window.confirm("Est de vous sûr de vouloir vous déconnecter ? Vous pourrez vous reconnecter et reprendre sur cette page plus tard.")) {
      await authClient.signOut(
        {},
        {
          onSuccess: () => {
            console.log("Successfully signed out");
            window.location.reload();
          },
          onError: () => {
            toast.error("Failed to sign out");
            window.location.reload();
          },
        }
      );
    }
  };

  const showBackButton = !(path.includes("step1") || path === "/onboarding" || path === "/login");

  const handleBack = () => {
    if (path.includes("onboarding")) {
      handleSignOut();
    } else {
      window.history.back();
    }
  };

  return (
    <div
      className="sticky top-0 left-0 z-50 flex w-full max-w-[400px] flex-col items-start gap-4 bg-white/50 px-4 pt-4 pb-4 backdrop-blur-[2px] sm:max-w-full lg:w-[450px] lg:max-w-none"
      style={{
        background: "linear-gradient(to bottom, rgba(255,255,255,0.95) 85%, rgba(255,255,255,0.05) 100%)",
      }}
    >
      <a href="/" className="flex items-center gap-4 text-2xl font-bold hover:underline">
        <img src={nautikaIcon} alt="Nautika" className="h-8 w-8" />
        Nautika
      </a>
      {showBackButton && (
        <div className="w-full">
          <Button variant="link" onClick={handleBack} className="flex w-full justify-start text-gray-500 hover:text-gray-700">
            <ArrowLeft className="mr-2 h-4 w-4" />
            {path.includes("onboarding") ? "Quitter l'inscription" : "Retour"}
          </Button>
        </div>
      )}
    </div>
  );
}

export default function AuthLayout() {
  const [right, setRight] = useState<RightRenderer>(
    <div className="flex h-full flex-1 items-center justify-center overflow-hidden p-6 text-6xl font-bold">Nautika</div>
  );

  return (
    <div className="fixed inset-0 h-screen w-screen overflow-hidden">
      <div className="absolute inset-0 bg-white/20" />

      <div className="relative z-10 flex h-full lg:flex-row">
        {/* ← Colonne LEFT */}
        <div className="flex h-full w-full max-w-none flex-col overflow-y-auto bg-white/95 shadow-lg md:max-w-[450px] lg:w-[30vw] lg:max-w-[500px] lg:min-w-[450px]">
          <Header />

          <div className="flex flex-1 items-center justify-center px-8 py-4">
            <div className="relative -top-6 flex w-full max-w-md flex-col items-center gap-12">
              <Outlet context={{ setRight } satisfies LayoutCtx} />
            </div>
          </div>
        </div>

        {/* → Colonne RIGHT */}
        <aside
          className="hidden h-full flex-1 items-center justify-center overflow-hidden p-6 md:flex"
          style={{
            backgroundImage: `url(${plageBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {right}
        </aside>
      </div>
    </div>
  );
}
